import { BaseTileRenderer }  from '@wizeoo/akm-common-lib';
import { BusinessUnitVO } from '@wizeoo/akm-common-lib';
import { Component, ViewChild } from '@angular/core';
import { IWizItemRenderer } from '@wizeoo/akm-component-lib';

/**
 * Vignette de présentation d'une entité métier pour l'affichage en mode vignette du MultiDisplay
 */

@Component({
  selector: 'md-bu-tile-renderer',
  templateUrl: './md-bu-tile.renderer.html',
})
export class MdBusinessUnitTileRenderer implements IWizItemRenderer<null, BusinessUnitVO> {
  @ViewChild('mdBusinessUnitTileRenderer', { read: BaseTileRenderer, static: true })
  mdTileRenderer: BaseTileRenderer;

  // Le VO manipulé
  private _data: BusinessUnitVO;
  public get data(): BusinessUnitVO {
    return this._data;
  }
  public set data(data: BusinessUnitVO) {
    this._data = data;
    this.mdTileRenderer.data = data;
    // La notion depréciée pour les entités métiers est portée par la notion d'organisation désactivée
    this.mdTileRenderer.deprecated = data !== null && data.deactivated;
  }
}
